const posts = [
  {
    slug: "mental-models-to-cultivate",
    mdFile: "2024-09-16.md",
    cover: "cover-balanced-mind.png",
    title: "Foundational Mental Models to Accomplish Alignment",
    date: "Sep 16th, 2024",
    excerpt:
      "Join me as I share some paradigms that form a positive and productive mindset. I do my best to nurture and practice the below but needless to say this is by no means an exhaustive list.",
  },
  {
    slug: "on-leadership-and-management",
    mdFile: "2024-09-15.md",
    cover: "cover-team-collab.png",
    title: "Exploring Effective Leadership and Management Practices",
    date: "Sep 15th, 2024",
    excerpt:
      "You can manage and lead with or without authority from any role. That being said, people management is often assigned while leadership is often natural or assumed. The main prerequisite to both is learning to manage yourself prior to guiding others. Let's dive in.",
  },
  {
    slug: "real-real-on-pm",
    mdFile: "2024-07-20.md",
    cover: "team.png",
    title: "Understanding the Essence of Product Management in Software Development",
    date: "Jul 20th, 2024",
    excerpt:
      "Building successful software products requires agility in experimentation, innovation, and decision-making. When engineers are head down focused on implementing new capabilities, a need for a leader and visionary to represent the product as a whole is met by PMs.",
  },
  {
    slug: "developer-productivity-101",
    mdFile: "2024-04-06.md",
    cover: "developer.png",
    title: "Defining and Quantifying Developer Productivity: A Comprehensive Framework",
    date: "Apr 6th, 2024",
    excerpt:
      "Developers spend about half their day on average in individual activities from reading and writing code and tests, debugging and reviewing code, documentation, and specification.",
  },
  {
    slug: "fundamental-concepts-in-genai",
    mdFile: "2024-03-02.md",
    cover: "cover-machine-learning.png",
    title: "Fundamental Concepts in Machine Learning (ML)",
    date: "Mar 2nd, 2024",
    excerpt:
      "The rapid pace at which new developments in the Generative AI (GenAI) field were announced, weekly if not daily, leading to increased excitement and ambiguity. Today, we seem to have reached a level of comfort and maturity as we understood the capabilities of the technology, its current limitation, and future direction. Let's review foundational concepts in Machine Learning, all the way to GPT.",
  },
  {
    slug: "how-to-avoid-a-climate-disaster",
    mdFile: "2024-01-06.md",
    cover: "climate-change-01.png",
    title: 'Takeaways from "How to Avoid a Climate Disaster"',
    date: "Jan 6th, 2024",
    excerpt:
      "A primer on climate change. Bill Gates writes an overview of the challenge in hand, supports it with data, and delineates next steps we need to take to resolution.",
  },
  {
    slug: "thoughts-on-sales-engineering",
    mdFile: "2021-08-21.md",
    cover: "cover-san-francisco.png",
    title: "Sales Engineering Growth Paths in the Technology Industry",
    date: "Aug 21st, 2021",
    excerpt:
      "An SE role is multi-dimensional. You need strong technical skills, but without an equally established non-technical skillset, those technical skills will not be put to use effectively.",
  },
];

export default posts;
